module.exports = __webpack_public_path__ + "img/skull_5_bj.4811d77e.png";